<template>
  <JobList isMSDCustom :company="companyInfo"></JobList>
</template>

<script>
import JobList from '../../pc/jobList.vue'
export default {
  components: {
    JobList
  },
  metaInfo () {
    return {
      title: '默沙东社会招聘',
      meta: [
        {
          name: 'keywords',
          content: '默沙东中国, 默沙东招聘, 默沙东职位, 职业生涯, 社会招聘'
        },
        {
          name: 'description',
          content: '加入我们，与全球默沙东员工一起为生命增辉'
        }
      ]
    }
  },
  props: {
    company: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    companyInfo () {
      return this.company
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
